import { Component, inject, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { combineLatest } from 'rxjs'
import { CallsService } from '../calls.service'
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component'
import { MatDialog } from '@angular/material/dialog'
import { TranslateModule, TranslateService } from '@ngx-translate/core'
import { ToastService } from '../toast.service'

@Component({
  selector: 'app-hang-up-page',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './hang-up-page.component.html',
  styleUrl: './hang-up-page.component.scss',
})
export class HangUpPageComponent implements OnInit {
  route = inject(ActivatedRoute)
  callsService = inject(CallsService)
  dialog = inject(MatDialog)
  translateService = inject(TranslateService)
  toastService = inject(ToastService)

  success = false

  currentCallId = parseInt(this.route.snapshot.params['id'], 10)
  hangUpKey = this.route.snapshot.queryParams['hang-up-key']

  async ngOnInit(): Promise<void> {
    this.translateService.use('en').subscribe(() => {
      this.hangUpCall()
    })
  }

  async hangUpCall() {
    combineLatest([
      this.translateService.get('CALLS.HANG_UP.DIALOG_TITLE'),
      this.translateService.get('CALLS.HANG_UP.DIALOG_BODY_ANONYMOUS'),
      this.translateService.get('COMMON.YES'),
    ]).subscribe(([title, description, confirmLabel]) => {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        data: {
          title,
          description,
          confirmLabel,
        },
      })

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.callsService.hangUpCallAnonymously(this.currentCallId, this.hangUpKey).subscribe((success) => {
            this.success = success
          })
        }
      })
    })
  }
}
